export default __webpack_public_path__ + "static/media/HipLock.352c4eaf.png";